<template>
  <div class="wrapper">
    <div class="header">
      <p class="custom-title">Can't Disable Touch Mode</p>
    </div>
    <i
      @click="$bvModal.hide('touchModeAlert')"
      class="mdi mdi-close-circle close-icon"
    ></i>
    <div class="content">
      <p class="touch-mode-alert">
        <template v-if="disableReason.regNotReq">
          To disable the touch mode, the journey should have only one
          "Registeration not required" user type selected.
        </template>

        <template v-else-if="disableReason.no_input">
          To disable the touch mode, all the flows should have at least one
          input type selected.
        </template>

        <template v-else-if="!getIsValidateRemoteJourney">
          To disable the touch mode, all the flows should have at least one input type selected and not assigned to a normal area.
        </template>
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "TouchModeAlert",
  props: ["disableReason"],
  computed: {
    ...mapGetters("journey", [
      "getIsValidateRemoteJourney",
    ]),
  },
};
</script>

<style lang="scss" scoped>
.header {
  margin-bottom: 38px;
  .custom-title {
    font-weight: bold;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
    color: #c7c7c7;
    margin-bottom: 0 !important;
    letter-spacing: 1px;
  }
}
.close-icon {
  position: absolute;
  top: 21px;
  inset-inline-end: 26px;
  color: #f46a6a;
  font-size: 1.7rem;
  cursor: pointer;
}
.touch-mode-alert {
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  color: #495057;
  padding: 0 22px;
}
</style>
